import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  apiGatewayUrl: string;

  constructor(private http: HttpClient) {
    this.apiGatewayUrl = environment().apiGatewayUrl;
  }

  uploadVideo(applicantId: string, scopeKey: string, durationInSeconds: number, video: File) {
    const formData = new FormData();
    formData.append('file', video, video.name);

    return this.http.post<any>(
      `${this.apiGatewayUrl}media/applicants/${applicantId}/videos?scopeKey=${scopeKey}&durationInSeconds=${durationInSeconds}`,
      formData,
      { headers: { hostname: location.hostname }, observe: 'response' });
  }

  downloadVideo(applicantId: string, mediaId: number) {
    return this.http.get(
      `${this.apiGatewayUrl}media/applicants/${applicantId}/videos/${mediaId}/file`,
      { responseType: 'blob' });
  }
}
